import styled from '@emotion/styled'
import { prop } from 'lodash/fp'
import React from 'react'

import { Card, Loader } from 'packages/common'
import { IconName, SvgIcon } from 'packages/iconic'
import { colors, text } from 'packages/styles'
import { format } from 'packages/utils/dateHelpers'

import { ComputedWorkingStatus } from 'app/fieldapp/store/coverage/coverage.types'
import { useDayOfWeekTranslationShort } from 'app/fieldapp/utils/hooks/useDateTranslations'

const St = {
  Card: styled(Card)`
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-width: 100px;
    padding: 8px;
    position: relative;
  `,
  Date: styled.h3`
    ${text.headingDefault};
    display: inline-block;
    margin: 0;
  `,
  DayName: styled.h4`
    ${text.headingLabel};
  `,
  StatusIcon: styled(SvgIcon)<{ color: string }>`
    color: ${prop('color')};
  `,
}

export enum DayCalendarCardTestIds {
  container = 'DayCalendarCard__container',
}

const WorkingStatusIconMap: Record<
  ComputedWorkingStatus,
  { color: string; icon: IconName }
> = {
  off: {
    color: colors.keyWest,
    icon: IconName.availability,
  },
  on: {
    color: colors.midnight70,
    icon: IconName.availability,
  },
  partial: {
    color: colors.midnight70,
    icon: IconName.partialAvailability,
  },
}

export type DayCalendarCardProps = {
  date: Date
  isLoading: boolean
  onClick?: () => void
  workingStatus: ComputedWorkingStatus
}

export const DayCalendarCard: React.FC<DayCalendarCardProps> = React.memo(
  ({ date, isLoading, onClick, workingStatus }) => {
    const translateDate = useDayOfWeekTranslationShort()
    const iconConfig = WorkingStatusIconMap[workingStatus]
    return (
      <St.Card dataTestId={DayCalendarCardTestIds.container} onClick={onClick}>
        {isLoading && <Loader />}
        <St.Date>{format(date, 'dd')}</St.Date>
        <St.DayName>{translateDate(date)}</St.DayName>
        <St.StatusIcon
          color={iconConfig.color}
          height={8}
          icon={iconConfig.icon}
          width={25}
        />
      </St.Card>
    )
  },
)
